<template>
    <div id="app">
        <container></container>
    </div>
</template>

<script>
import container from "./views/Container"

export default {
    components: { container },
    data() {
        return {}
    },
    async mounted() {
        this.$router.afterEach((to, from) => {
            this.$nextTick(() => {
                document.querySelector("#content-conatiner").scrollTo({top: 0, behavior: 'smooth'})
            })
        })
        await this.$store.dispatch("listCategories")
        this.$store.dispatch("listJourneys")
    }
}
</script>

<style>
#app {
    font-family: arial !important;
    height: 100%;
    user-select: none;
}
</style>
